import { Image, StyleSheet } from '@react-pdf/renderer'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props, ref) => {
	const styles = StyleSheet.create({ image: p.styles || {} })

	return <Image {...p} {...p.customProps} style={styles.image} />
})
